// extracted by mini-css-extract-plugin
module.exports = {"summary":"_2821a90","summaryContainer":"_2bd2e5c","summaryIcon":"_15e085e","body":"_392314e","promotionsMessage":"_de4688a"};